import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { trackLead } from '../utils/metaPixel';

const HeroSection = () => {
  const scrollToPathway = (e) => {
    e.preventDefault();
    const element = document.querySelector('#pathway');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="max-w-3xl px-4 sm:px-0 pt-8 md:pt-0">
          {/* Eyebrow */}
          <p className="eyebrow-gold uppercase tracking-widest mb-6 animate-fade-in-up">
            Protection Guardianship™ by Overflow Nation
          </p>
          
          {/* Main Headline */}
          <h1 className="hero-large mb-4 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            Certainty for your family—
            <span className="block">without sales pressure.</span>
          </h1>
          
          {/* Disqualification line */}
          <p className="text-sm text-[var(--text-light)] italic mb-8 animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            If you're looking for quotes or comparisons, this may not be the right place.
          </p>
          
          {/* Subheadline */}
          <p className="body-large text-[var(--text-secondary)] mb-10 max-w-xl animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Protection Guardianship™ is a structured system that turns confusion into calm clarity. Not selling insurance. Building certainty.
          </p>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-6 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <a
              href="https://wa.me/9172096199"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
              onClick={() => trackLead('Hero WhatsApp Click')}
            >
              Start Your Protection Review
              <ArrowRight size={16} />
            </a>
            <button
              onClick={scrollToPathway}
              className="btn-primary"
            >
              View the Pathway
              <ChevronDown size={16} />
            </button>
          </div>
          
          {/* WhatsApp micro-clarity */}
          <p className="text-sm text-[var(--text-secondary)] mb-4 animate-fade-in-up" style={{ animationDelay: '0.35s' }}>
            Send "CLARITY" on WhatsApp to begin your structured protection review.
          </p>
          
          {/* CTA micro-filter */}
          <p className="text-xs text-[var(--text-light)] mb-16 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            Serious families only • No quotes • No product selling
          </p>
          
          {/* Signature filter line - centered */}
          <div className="text-center mt-8 pt-8 border-t border-[var(--border-light)] animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <p className="text-xs tracking-wide text-[var(--text-light)] opacity-70 uppercase">
              Designed for serious families seeking clarity — not quotes or comparisons.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
